import { Analysis } from "./pages/analysis/analysis";
import { Dashboard } from "./pages/dashboard/Dashboard.jsx";
import { Login } from "./pages/login/login";
import { IntelligenceCenter } from "./pages/intelligence_center/IntelligenceCenter.jsx";
import { Navbar } from "./components/navbar/navbar";
import { ManagedAttribution } from "./pages/managedAttribution/managedAttribution";
import { News } from "./pages/news/news";
import { ProtectedPersons } from "./pages/protected persons/protected_persons";
import { ThreatFeed } from "./pages/threats/ThreatFeed.jsx";
import { Search } from "./pages/search/search";
import { ScrollToTop } from './components/ScrollToTop';
import { NavBarIndicator } from "./components/NavBarIndicator.jsx";
import { ProtectedRoute } from "./components/protectedRoute.jsx";
import { Resources } from "./pages/resources/Resources.jsx";

import { Users } from "./pages/users/users";
import "./App.scss";

import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <NavBarIndicator>
          <Navbar />
        </NavBarIndicator>

        <Routes>
          {/* Public route */}
          <Route path="/login" element={<Login />} />

          {/* Protected routes */}
          <Route path="/" element={<ProtectedRoute><IntelligenceCenter /></ProtectedRoute>} />
          <Route path="/intelligenceCenter" element={<ProtectedRoute><IntelligenceCenter /></ProtectedRoute>} />
          <Route path="/analytics" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/assessments" element={<ProtectedRoute><Analysis /></ProtectedRoute>} />
          <Route path="/managedAttribution" element={<ProtectedRoute><ManagedAttribution /></ProtectedRoute>} />
          <Route path="/news" element={<ProtectedRoute><News /></ProtectedRoute>} />
          <Route path="/monitoring" element={<ProtectedRoute><ProtectedPersons /></ProtectedRoute>} />
          <Route path="/threatFeed" element={<ProtectedRoute><ThreatFeed /></ProtectedRoute>} />
          <Route path="/users" element={<ProtectedRoute><Users /></ProtectedRoute>} />
          <Route path="/search" element={<ProtectedRoute><Search /></ProtectedRoute>} />
          <Route path="/resources" element={<ProtectedRoute><Resources /></ProtectedRoute>} />

          {/* Catch-all: redirect based on auth */}
          <Route
            path="*"
            element={
              <ProtectedRoute redirectPath="/login">
                <IntelligenceCenter />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;